// extracted by mini-css-extract-plugin
export var focused = "index-module--focused--7af46";
export var primary = "index-module--primary--0021e";
export var secondary = "index-module--secondary--97020";